import { render, staticRenderFns } from "./recommend.vue?vue&type=template&id=aa323edc&scoped=true&"
import script from "./recommend.vue?vue&type=script&lang=js&"
export * from "./recommend.vue?vue&type=script&lang=js&"
import style0 from "./recommend.vue?vue&type=style&index=0&id=aa323edc&lang=scss&scoped=true&"
import style1 from "./recommend.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa323edc",
  null
  
)

export default component.exports